import { ApiService } from "./api-service";
import {
  IEntityUsageHistoryItemResponse,
  IEntityMetricsResponse,
  IEntityUsageHistoryRequest,
} from "../entities/metrics";

class MetricsServiceHelper {
  async getMetrics(
    api: ApiService,
    ids: string | string[]
  ): Promise<IEntityMetricsResponse[]> {
    let idList: string[] = [];
    if (typeof ids === "string") {
      idList = [ids];
    } else {
      idList = ids;
    }
    if (ids === null || isEmpty(idList)) {
      return [];
    }

    return api.post<IEntityMetricsResponse[]>("metrics", { ids: idList });
  }

  async getUsageHistory(
    api: ApiService,
    params: IEntityUsageHistoryRequest
  ): Promise<IEntityUsageHistoryItemResponse[]> {
    if (!isValidHistoryParam(params)) {
      return [];
    }

    let history: Promise<IEntityUsageHistoryItemResponse[]> = api
      .post<IEntityUsageHistoryItemResponse[]>("metrics/history", params)
      .catch(() => {
        return [];
      });
    return history;
  }
}

function isValidHistoryParam(params: IEntityUsageHistoryRequest) {
  return (
    !isEmpty(params.id) &&
    !isEmpty(params.startTime) &&
    !isEmpty(params.endTime)
  );
}

function isEmpty(val: string | any[]): boolean {
  return val.length === 0;
}

export const metricsServiceHelper = new MetricsServiceHelper();
